<template>
  <div class="component-score-box">
    <!-- //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题 -->
    <!-- 解答题不需要留白 后来改为所有题型不需要题号高度留白 -->
    <template v-if="isPreview">
      <span v-if="msg.hasTitle" :title="msg.name">
        <span v-if="msg.editName">
          {{ msg.editName }}
        </span>
        <span v-else>
          {{
            `${msg.th}、${msg.name && msg.name.substr(0, 38)}${
              msg.name && msg.name.length > 38 ? "..." : ""
            }`
          }}
          <span class="score" v-if="!answerSheet.acCardHideScore"
            >（{{
              parseInt(msg.totalScore) == msg.totalScore
                ? msg.totalScore
                : (String((msg.totalScore && msg.totalScore.toFixed(1))).split(".")[1] == "0"
                    ? String((msg.totalScore && msg.totalScore.toFixed(1))).split(".")[0]
                    : (msg.totalScore && msg.totalScore.toFixed(1))) || 2
            }}分）</span
          >
        </span>
      </span>
      <span v-else></span>
    </template>
    <template v-else>
      <span v-if="msg.hasTitle" :title="msg.name">
        <el-input
          v-model="scoreValue"
          :maxlength="answerSheet.acCardPanes == 3 ? 35 : 40"
          placeholder="请输入内容"
          @blur="handlerBlur"
          @focus="handlerFocus"
          class="title_input"
        ></el-input>
      </span>
    </template>
    <div
      v-if="showScoreBox && msg.type != 2 && !msg.eachBlankScore"
      class="score-box"
      :style="`top:${msg.hasTitle ? '41px' : '.5px'}`"
    >
      <div class="s-text">
        得
        <br />分
      </div>
    </div>
  </div>
</template>

<script>
//  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
import { mapState, mapGetters, mapMutations } from "vuex";
import { editScoreBoxMixins } from "../../../mixins/editScoreBox.mixins";

export default {
  props: ["msg", "isPreview"],
  mixins: [editScoreBoxMixins],
  computed: {
    ...mapState("answerPanel", {
      answerSheet: (state) => state.answerSheet,
    }),
    showScoreBox() {
      let result = false;
      if(this.answerSheet.acCardYJType == 0) {
        result = true;
        if( this.msg.type != 3 && !this.msg.hasTitle) {
          result = false;
        } else if ( this.msg.type == 3 && this.msg.isSub ) {
          result = false;
        } else if (this.msg.type == 2) {
          result = false;
        } 
       
      }
      return result;
    }
  },
  data() {
    return {
      scoreValue: "",
    };
  },
  methods: {
    initScoreBox(target, type) {
      let topicName = `${target.th}、${
        target.name && target.name.substr(0, 38)
      }${target.name && target.name.length > 38 ? "..." : ""}`;
      if (target.editName) {
        // editName不为undefined的话 则嗲表用户编辑过标题并且保存了则优先展示editName
        this.scoreValue = target.editName;
      } else {
        if (!this.answerSheet.acCardHideScore) {
          this.scoreValue =
            topicName +
            "（" +
            (parseInt(target.totalScore) == target.totalScore
              ? target.totalScore
              : (String(target.totalScore && target.totalScore.toFixed(2)).split(".")[1] == "00"
                  ? String(target.totalScore && target.totalScore.toFixed(2)).split(".")[0]
                  : target.totalScore && target.totalScore.toFixed(2)) || 2) +
            "分）";
        } else {
          this.scoreValue = topicName;
        }
      }
    },
    handlerBlur(val) {
      this.$emit("myBlur", val.target.value);
    },
  },
  watch: {
    msg: {
      handler(newVal) {
        this.initScoreBox(newVal);
      },
      deep: true,
    },
  },
  mounted() {
    this.initScoreBox(this.msg);
  },
};
</script>

<style lang='scss' >
.component-score-box {
  position: relative;
}
.score-box {
  position: absolute;
  display: flex;
  right: 1px;
  top: 41px;
  width: 85px;
  height: 34px;
  box-sizing: border-box;
  border: 1px solid #000;
  z-index: 999;
  border-top: none;
  border-right: none;
  background: #fff;
  opacity: 0.8;
  font-size: 12px;
}
.score-box .s-text {
  padding: 0 3px;
  line-height: 16px;
  border-right: 1px solid #000;
}
.title_input input {
  border:1px solid transparent !important;
  border-radius: 0px !important;
  box-sizing: border-box;
}
.title_input input:hover {
  border: 1px solid #4891ff !important;
  border-bottom:1px solid transparent !important;
}
.component-score-box .el-input__inner{
  color: #000;
  padding: 0 !important;
}
</style>